import { shopCall } from '../shop-shared/transport';
import type { ShopRestInit } from '../shop-shared/transport';
import type { CartFullDetails } from './types';

export function getCartFullDetails(init: ShopRestInit): Promise<CartFullDetails> {
    return shopCall<CartFullDetails>(init, 'gas_get_cart_full_details', {});
}

export function updateCartQuantity(init: ShopRestInit, itemId: number, quantity: number): Promise<unknown> {
    return shopCall(init, 'gas_update_cart_quantity', { item_id: itemId, quantity });
}

export function removeFromCart(init: ShopRestInit, itemId: number): Promise<unknown> {
    return shopCall(init, 'gas_remove_from_cart', { item_id: itemId });
}

export interface CouponResult {
    message?: string;
}

export function applyCoupon(init: ShopRestInit, couponCode: string): Promise<CouponResult> {
    return shopCall<CouponResult>(init, 'gas_apply_coupon', { coupon_code: couponCode });
}

export function removeCoupon(init: ShopRestInit): Promise<unknown> {
    return shopCall(init, 'gas_remove_coupon', {});
}

export function emptyCart(init: ShopRestInit): Promise<unknown> {
    return shopCall(init, 'gas_empty_cart', {});
}
